import React from 'react';

import { useQuery } from "react-query";

import { fetchFMCPFileShouldExist } from 'utils/ts-queries';

import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

import ReclamationFichierFMCP from './ReclamationFichierFMCP';

type Props = {
  reclamationId: number;
};



export default function ReclamationCheckFichierFMCP({reclamationId} : Props) {

  const { isLoading, isError, data } =
      useQuery({
          queryKey: [
              'check-reclamation-fmcp-file-should-exist',
              reclamationId
          ],
          queryFn: () => fetchFMCPFileShouldExist({
              reclamationId
          }),
          cacheTime: 60000
      })


  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', p: 1 }}>
        <CircularProgress size={20} />
      </Box>
    );
  }

  if (!data) {
    return null;
  }

  return (
    <ReclamationFichierFMCP reclamationId={reclamationId} />
  );
}